import React, { FC, memo } from "react";

import { LoadFileBlock } from "./LoadFileBlock";
import { ImportFileLoaderProps } from "./types";

export const fileIs = (file: Pick<File, "type">, types: string[]): boolean => types.indexOf(file.type) > -1;

const ImportFileLoaderComponent: FC<ImportFileLoaderProps> = ({ fileRef, upload }) => (
  <>
    <LoadFileBlock />
    <input
      onChange={e => upload(e.target.files[0])}
      ref={el => (fileRef.current = el)}
      type="file"
      accept={".xlsx,.csv,.zip,.json,.geojson,.zip,.kml,.kmz"}
      hidden
    />
  </>
);

export const ImportFileLoader = memo(ImportFileLoaderComponent);
